export function listElements(search, elements, nameGetter) {
	return search
		? elements.filter((e) => nameGetter(e)?.toLowerCase()?.includes(search.toLowerCase()))
		: elements;
}
